import { post, get } from "../util/crmAxios";

// 新增编辑账号 添加员工
export const addEditAccount = (params) => post('/crm/accountcenter/addEditAccount', params);

// 禁用账号
export const disableAccount = (params) => post('/crm/accountcenter/disableAccount', params);

// 重新邀约
export const reApplyAccount = (params) => post('/crm/accountcenter/reApplyAccount', params);
// 取消邀约
export const cancelApplyAccountCenter = (params) => post('/crm/accountcenter/cancelApplyAccountCenter', params);
// 重新激活
export const reActiveAccount = (params) => post('/crm/accountcenter/reActiveAccount', params);
// 账号查询
export const queryAccount = (params) => post('/crm/accountcenter/queryAccount', params);
// 账号查询新
export const queryAccountCenterList = (params) => post('/crm/accountcenter/queryAccountCenterList', params);
// 离职记录
export const getLeaveUserList = (params) => post('/crm/accountcenter/getLeaveUserList', params);
// 交接记录
export const getUserHandoverRecord = (params) => post('/crm/accountcenter/getUserHandoverRecord', params);
// 修改记录
export const getOperationRecords = (params) => post('/crm/accountcenter/getOperationRecords', params);
// 离职资产信息
export const getUserLeaveAssetInfo = (params) => post('/crm/accountcenter/getUserLeaveAssetInfo', params);
// 员工离职交接资产详情
export const getUserLeaveAssetDetail = (params) => post('/crm/accountcenter/getUserLeaveAssetDetail', params);
// 员工离职交接人列表
export const getHandoverUserList = (params) => post('/crm/accountcenter/getHandoverUserList', params);
// 禁用详情
export const getAccountDisableDetail = (params) => post('/crm/accountcenter/getAccountDisableDetail', params);
// 冻结详情
export const getAccountFreezeDetail = (params) => post('/crm/accountcenter/getAccountFreezeDetail', params);
// 启用账号
export const enableAccount = (params) => post('/crm/accountcenter/enableAccount', params);
// 员工账户离职
export const userLeave = (params) => post('/crm/accountcenter/userLeave', params);
// 醒员工账号
export const wakeUpAccount = (params) => post('/crm/accountcenter/wakeUpAccount', params);
// 督学师的成绩收集
export const teacherTarget = (params) => post('/erp/student/teacherTarget', params);
// 成绩收集
export const centerTarget = (params) => post('/erp/student/centerTarget', params);